import axios from 'axios';

const authApi = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_AUTH_API_URL,
});

export default authApi;
